import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import { onStepBack } from './actions';
import { MIN_PAYMENT_AMOUNT } from './constants';
import { CURRENCIES, DEFAULT_CURRENCY } from 'common/const';

const LangSelectionTotal = ({
    selectedOptions,
    wordCount,
    quotation,
    onCheckout,
    onStepBack
}) => {
    const onCheckoutClick = () => {
        onCheckout();
    };

    const currency = CURRENCIES[get(quotation, 'currency')] || DEFAULT_CURRENCY;

    const icon = get(currency, 'ICON');
    const minimumFee = get(quotation, 'minimumFee', MIN_PAYMENT_AMOUNT);
    const sumCost = get(quotation, 'sumCost', 0);
    // Below the minimum, checkout charges the minimum. Say so now, not
    // only on the payment page.
    const belowMinimum = sumCost > 0 && sumCost < minimumFee;

    return (
        <div className="ld-bar">
            <dl className="ld-bar-stats">
                <div className="ld-stat">
                    <dt>Languages</dt>
                    <dd>{selectedOptions.length}</dd>
                </div>
                <span className="ld-bar-divider" aria-hidden="true" />
                <div className="ld-stat">
                    <dt>Source words</dt>
                    <dd>{wordCount}</dd>
                </div>
                <span className="ld-bar-divider" aria-hidden="true" />
                <div className="ld-stat ld-stat-total">
                    <dt>Price so far, VAT not included</dt>
                    <dd className="ld-stat-price">
                        {icon} {sumCost}
                    </dd>
                </div>
                {belowMinimum && (
                    <React.Fragment>
                        <span className="ld-bar-divider" aria-hidden="true" />
                        <div className="ld-stat ld-stat-min">
                            <dt>Minimum order, you pay</dt>
                            <dd>
                                {icon} {minimumFee}
                            </dd>
                        </div>
                    </React.Fragment>
                )}
            </dl>
            <div className="ld-bar-actions">
                <button
                    type="button"
                    className="btn ld-btn-ghost"
                    onClick={onStepBack}
                >
                    Back
                </button>
                <button
                    type="button"
                    className="btn btn-next"
                    disabled={!(quotation && quotation.sumCost)}
                    onClick={onCheckoutClick}
                >
                    Continue
                </button>
            </div>
        </div>
    );
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return bindActionCreators({ onStepBack }, dispatch);
};

export default connect(null, mapDispatchToProps)(LangSelectionTotal);
